import { supabase, TABLES } from '../lib/supabase';

class CommentService {
  // Add a comment to an article
  async addComment(articleId, commentData) {
    try {
      const { data, error } = await supabase
        .from(TABLES.COMMENTS)
        .insert([{
          ...commentData,
          article_id: articleId,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          approved: false, // Comments need approval
          likes: 0
        }])
        .select()
        .single();

      if (error) throw error;
      return data.id;
    } catch (error) {
      console.error('Error adding comment:', error);
      throw error;
    }
  }

  // Get comments for an article
  async getComments(articleId, approved = true) {
    try {
      let query = supabase
        .from(TABLES.COMMENTS)
        .select('*')
        .eq('article_id', articleId)
        .order('created_at', { ascending: false });

      if (approved) {
        query = query.eq('approved', true);
      }

      const { data, error } = await query;
      if (error) throw error;
      
      return data || [];
    } catch (error) {
      console.error('Error getting comments:', error);
      throw error;
    }
  }

  // Approve a comment
  async approveComment(commentId) {
    try {
      const { data, error } = await supabase
        .from(TABLES.COMMENTS)
        .update({
          approved: true,
          updated_at: new Date().toISOString()
        })
        .eq('id', commentId)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error approving comment:', error);
      throw error;
    }
  }

  // Delete a comment
  async deleteComment(commentId) {
    try {
      const { error } = await supabase
        .from(TABLES.COMMENTS)
        .delete()
        .eq('id', commentId);

      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error deleting comment:', error);
      throw error;
    }
  }

  // Get all pending comments for moderation
  async getPendingComments() {
    try {
      const { data, error } = await supabase
        .from(TABLES.COMMENTS)
        .select(`
          *,
          articles:article_id (
            title
          )
        `)
        .eq('approved', false)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error getting pending comments:', error);
      throw error;
    }
  }

  // Like a comment
  async likeComment(commentId, userId) {
    try {
      const { data, error } = await supabase.rpc('toggle_comment_like', {
        comment_id: commentId,
        user_id: userId
      });
      
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error liking comment:', error);
      throw error;
    }
  }
}

export default new CommentService();